import { useMemo } from 'react';
import { SpreadsheetConfig } from 'components/ScalarSpreadsheet/utilities/SpreadsheetConfig';
import { EXCHANGE_RATE_ALIAS, EXCHANGE_RATE_SHEET_NAME } from './ExchangeRateSheet.constants';

export const useCreateExchangeRateSheet = () => {
  const exchangeRateSheet = useMemo(() => {
    const columns = [{}];
    const rowConfig = [
      {
        alias: EXCHANGE_RATE_ALIAS,
      },
    ];
    const parser = () => ({
      A1: {
        alias: EXCHANGE_RATE_ALIAS,
        key: 'A1',
        customKey: EXCHANGE_RATE_ALIAS,
        rowNumber: 1,
        columnLegend: 'A',
        value: null,
      },
    });
    // @ts-expect-error: The constructor type includes runtime methods that SpreadsheetConfig initializes itself.
    return new SpreadsheetConfig({
      columns,
      rowConfig,
      tableData: {},
      parser,
      name: EXCHANGE_RATE_SHEET_NAME,
      reverseParser: () => {},
    });
  }, []);

  return { exchangeRateSheet };
};
